export default __webpack_public_path__ + "static/media/6.940fa6f9.jpg";